<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Hojas de Carga</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item active">Argentina</li>
                  <li class="breadcrumb-item active">Operación</li>
                  <li class="breadcrumb-item active">Procesos</li>
                  <li class="breadcrumb-item active">Hojas de Carga</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border border-default"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <div class="btn-group" role="group">
                        <!-- <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal-form-solicitudes-export"
                          v-if="
                            $store.getters.can('argentina.hojasCarga.export')
                          "
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button> -->
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          v-if="
                            $store.getters.can('argentina.hojasCarga.create')
                          "
                          @click="create()"
                          data-bs-toggle="tooltip"
                          title="Crear nueva solicitud"
                        >
                          <i class="fas fa-plus me-1"></i>
                          Nueva Solicitud
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="getIndex()"
                          data-bs-toggle="tooltip"
                          title="Actualizar datos"
                        >
                          <i class="fas fa-sync-alt fa-spin me-1"></i>
                          Actualizar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <div class="row">
                      <!-- Filtro N° Interno -->
                      <div class="col-md-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-hashtag me-1"></i>
                          Interno
                        </label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          v-model="filtros.numero_interno"
                          @keyup.enter="getIndex()"
                          placeholder="Buscar ID..."
                        />
                      </div>
                      <!-- Filtro Remito -->
                      <div class="col-md-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-file-alt me-1"></i>
                          Remito
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.remito"
                          @keyup.enter="getIndex()"
                          placeholder="Buscar Remito..."
                        />
                      </div>
                      <!-- Filtro Isla -->
                      <div class="col-md-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Isla
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="isla"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.islas"
                          @input="getSelectIsla()"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>
                      <!-- Filtro Camion -->
                      <div class="col-md-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-truck me-1"></i>
                          Camión
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="camion"
                          label="placa"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.camiones"
                          @search="buscarCamiones"
                          @input="getSelectCamion()"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>
                      <!-- Filtro Chofer -->
                      <div class="col-md-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Chofer
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="chofer"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.choferes"
                          @input="getSelectChofer()"
                          @search="buscarChoferes"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>
                      <!-- Filtro Fecha -->
                      <div class="col-md-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </label>
                        <input
                          type="date"
                          class="form-control form-control-sm"
                          v-model="filtros.fecha"
                          @change="getIndex()"
                        />
                      </div>
                      <div class="col-md-2 d-flex align-items-end">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar Filtros
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Hojas de Carga
                  </h6>
                  <span class="badge bg-primary">
                    {{ hojasCargas.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table
                    class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center">
                          <i class="fas fa-hashtag me-1"></i> Interno
                        </th>
                        <th class="text-center">
                          <i class="fas fa-hashtag me-1"></i> Remito
                        </th>
                        <th>
                          <i class="fas fa-map-marker-alt me-1"></i>
                          Isla
                        </th>
                        <th>
                          <i class="fas fa-calendar me-1"></i>
                          Fecha
                        </th>
                        <th>
                          <i class="fas fa-clock me-1"></i>
                          Hora Inicio
                        </th>
                        <th>
                          <i class="fas fa-truck me-1"></i>
                          Camión
                        </th>
                        <th>
                          <i class="fas fa-truck-loading me-1"></i>
                          Cisterna
                        </th>
                        <th class="text-center">
                          <i class="fas fa-user-tie me-1"></i>
                          Chofer
                        </th>
                        <th class="text-center">
                          <i class="fas fa-check-circle me-1"></i>
                          Estado
                        </th>
                        <th class="text-center" style="width: 120px">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody class="text-center">
                      <tr
                        v-for="hoja_carga in hojasCargas.data"
                        :key="hoja_carga.id"
                      >
                        <td class="text-center">
                          <span class="badge bg-secondary">{{
                            hoja_carga.numero_interno
                          }}</span>
                        </td>
                        <td class="text-center">
                          <span class="badge bg-secondary">{{
                            hoja_carga.remito?.numero
                          }}</span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ hoja_carga.isla.nombre }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ hoja_carga.fecha }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ hoja_carga.hora_inicio }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ hoja_carga.camion.placa }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ hoja_carga.cisterna?.placa }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ hoja_carga.chofer?.nombres }}
                            {{ hoja_carga.chofer?.apellidos }}
                          </span>
                          <span class="badge bg-info small">
                            {{ hoja_carga.chofer?.numero_documento }}
                          </span>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            :class="
                              hoja_carga.estado == 1
                                ? 'bg-warning'
                                : hoja_carga.estado == 2
                                ? 'bg-success'
                                : 'bg-danger'
                            "
                          >
                            {{
                              hoja_carga.estado == 1
                                ? "Sin Imprimir"
                                : hoja_carga.estado == 2
                                ? "Impreso"
                                : "Anulado"
                            }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-outline-danger"
                              @click="anularHoja(hoja_carga)"
                              title="Anular Hoja de Carga"
                              v-if="
                                hoja_carga.estado != 3 &&
                                $store.getters.can(
                                  'argentina.hojasCarga.anular'
                                )
                              "
                            >
                              <i class="fas fa-ban"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can('argentina.hojasCarga.edit')
                              "
                              @click="edit(hoja_carga.id)"
                              title="Ver/Editar Hoja de Carga"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-danger"
                              v-if="
                                $store.getters.can('argentina.hojasCarga.pdf')
                              "
                              @click="printPDF(hoja_carga.id)"
                              title="Ver PDF de Hoja de Carga"
                            >
                              <i class="fas fa-file-pdf"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-success"
                              @click="enviarWhatsApp(hoja_carga.id)"
                              title="Enviar WhatsApp"
                              v-if="
                                $store.getters.can(
                                  'argentina.hojasCarga.envioWhatsapp'
                                ) && hoja_carga.estado != 3
                              "
                            >
                              <i class="fab fa-whatsapp"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="!hojasCargas.data || hojasCargas.data.length === 0"
                  class="text-center py-5"
                >
                  <i
                    class="fas fa-file-alt text-muted mb-3"
                    style="font-size: 3rem"
                  ></i>
                  <h5 class="text-muted">No hay hojas de carga para mostrar</h5>
                  <p class="text-muted">
                    Utiliza los filtros para buscar hojas de carga específicas
                  </p>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="hojasCargas.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        hojasCargas.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        hojasCargas.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        hojasCargas.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="hojasCargas"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    class="float-right m-0"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
export default {
  name: "HojasCargaIndex",
  components: {
    pagination,
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      filtros: {
        numero_interno: null,
        fecha: null,
        remito: null,
        camion_id: null,
        chofer_id: null,
        isla_id: null,
      },
      isla: {},
      camion: {},
      chofer: {},
      hojasCargas: {},
      listasForms: {
        estados: [],
        sitios: [],
      },
    };
  },
  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/argentina/hojasCargas?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.hojasCargas = response.data;
          this.cargando = false;
        });
    },

    getEstados() {
      this.cargando = true;
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
        this.cargando = false;
      });
    },

    getIslas() {
      this.cargando = true;
      axios
        .get("/api/argentina/sitios/lista", {
          params: {
            pais_id: 3,
          },
        })
        .then((response) => {
          this.listasForms.islas = response.data;
          this.cargando = false;
        });
    },

    buscarCamiones(search) {
      if (search != "") {
        let me = this;
        var url = "/api/argentina/camiones/lista?placa=" + search;
        axios
          .get(url)
          .then((response) => {
            me.listasForms.camiones = response.data;
          })
          .catch((error) => {
            me.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    buscarChoferes(search) {
      if (search != "") {
        let me = this;
        var url = "/api/argentina/choferes/lista?nombre=" + search;
        axios
          .get(url)
          .then((response) => {
            me.listasForms.choferes = response.data;
          })
          .catch((error) => {
            me.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getSelectCamion() {
      this.filtros.camion_id = this.camion.id;
      if (this.camion) {
        this.filtros.camion_id = this.camion.id;
      }
      this.getIndex();
    },

    getSelectChofer() {
      this.filtros.chofer_id = this.chofer.id;
      if (this.chofer) {
        this.filtros.chofer_id = this.chofer.id;
      }
      this.getIndex();
    },

    getSelectIsla() {
      this.filtros.isla_id = this.isla.id;
      if (this.isla) {
        this.filtros.isla_id = this.isla.id;
      }
      this.getIndex();
    },

    destroy(idSolicitud) {
      this.$swal({
        title: "Esta seguro de eliminar esta Solicitud?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        // <--
        if (result.value) {
          axios
            .delete("/api/hidrocarburos/solicitudes/" + idSolicitud)
            .then(() => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino la Solicitud exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Argentina/Operacion/HojasCargaForm",
        params: {
          accion: "Crear",
          id: null,
        },
      });
    },

    edit(hojaId) {
      return this.$router.push({
        name: "/Argentina/Operacion/HojasCargaForm",
        params: {
          accion: "Editar",
          id: hojaId,
        },
      });
    },

    printPDF(hoja_id) {
      axios
        .get("/api/argentina/hojasCarga/pdf/" + hoja_id)
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          window.open(data.url, "_blank");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Argentina/Operacion/HojasCargaPivotTable",
      });
    },

    limpiarFiltros() {
      this.filtros = {
        numero_interno: null,
        fecha: null,
        remito: null,
        camion_id: null,
        chofer_id: null,
        isla_id: null,
      };
      this.isla = {};
      this.camion = {};
      this.chofer = {};
      this.getIndex();
    },

    enviarWhatsApp(id) {
      let me = this;
      let url = "/api/argentina/hojasCarga/enviarWhatsApp/" + id;
      axios
        .get(url)
        .then((response) => {
          me.$swal({
            icon: "success",
            title: "WhatsApp enviado exitosamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    anularHoja(hoja) {
      this.$swal({
        title: "Anular Hoja de Carga",
        html: `
          <div style="text-align: left; margin-bottom: 20px;">
            <p><strong>Remito:</strong> ${hoja.remito.digito_verificacion} - ${hoja.remito.numero}</p>
            <p><strong>Chofer:</strong> ${hoja.chofer.nombres} ${hoja.chofer.apellidos}</p>
            <p><strong>Camion:</strong> ${hoja.camion.placa}</p>
            <p><strong>Cisterna:</strong> ${hoja.cisterna.placa}</p>
            <p><strong>Cliente:</strong> ${hoja.cliente.razon_social}</p>
            <p><strong>Empresa:</strong> ${hoja.empresa.razon_social}</p>
          </div>
          <div style="margin-top: 20px;">
            <label for="observaciones" style="display: block; margin-bottom: 8px; font-weight: bold;">Observaciones:</label>
            <textarea              
              id="observaciones"
              class="swal2-input" 
              placeholder="Ingrese las observaciones"
              required
              style="width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 4px;"
            ></textarea>
          </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Anular Hoja de Carga",
        cancelButtonText: "Cancelar",
        didOpen: () => {
          // Esperar un poco para que SweetAlert2 termine de renderizar
          setTimeout(() => {
            const input = document.getElementById("observaciones");
            const confirmButton = document.querySelector(".swal2-confirm");

            if (input && confirmButton) {
              // Ocultar el botón inicialmente
              confirmButton.style.visibility = "hidden";
              confirmButton.style.opacity = "0";
              confirmButton.disabled = true;

              // Función para verificar el input
              const checkInput = () => {
                const value = input.value.trim();
                if (value && parseInt(value) > 0) {
                  confirmButton.style.visibility = "visible";
                  confirmButton.style.opacity = "1";
                  confirmButton.disabled = false;
                } else {
                  confirmButton.style.visibility = "hidden";
                  confirmButton.style.opacity = "0";
                  confirmButton.disabled = true;
                }
              };

              // Verificar en tiempo real
              input.addEventListener("input", checkInput);
              input.addEventListener("keyup", checkInput);
              input.addEventListener("paste", () => {
                setTimeout(checkInput, 10);
              });
            }
          }, 200);
        },
        preConfirm: () => {
          const observaciones = document.getElementById("observaciones").value;

          if (!observaciones || observaciones.trim() === "") {
            // Mostrar mensaje de error usando SweetAlert2
            this.$swal({
              title: "Error",
              text: "Por favor ingrese observaciones válidas",
              icon: "error",
              confirmButtonText: "Entendido",
            });
            return false;
          }

          return observaciones;
        },
      }).then((result) => {
        if (result.value) {
          const observaciones = result.value;

          // Confirmación final
          this.$swal({
            title: "¿Confirmar anulación?",
            text: `¿Está seguro de anular la hoja de carga ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Enviar!",
            cancelButtonText: "Cancelar",
          }).then((confirmResult) => {
            if (confirmResult.value) {
              // Aquí puedes enviar los datos al backend
              this.anularSaveHoja(hoja.id, observaciones);
            }
          });
        }
      });
    },

    anularSaveHoja(hojaId, observaciones) {
      let me = this;
      me.cargando = true;
      axios
        .post("/api/argentina/hojasCarga/anular", {
          hoja_id: hojaId,
          observaciones: observaciones,
        })
        .then(() => {
          me.cargando = false;
          this.getIndex();
          me.$swal({
            icon: "success",
            title: "Hoja de carga anulada exitosamente",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          me.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          me.cargando = false;
        });
    },
  },
  mounted() {
    this.getIslas();
    this.getIndex();
  },
};
</script>
